import { Component, OnInit } from '@angular/core';
import { BusStudentsService } from '../_services/bus-students.service';
import { Filter } from 'src/app/user-management/_model/filter.model';
import { RoutesService } from '../_services/routes.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { EnrollError } from './enroll-error-interface'
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
declare var $: any;

@Component({
  selector: 'app-enroll-students-buses-system',
  templateUrl: './enroll-students-buses-system.component.html',
  styleUrls: ['./enroll-students-buses-system.component.scss']
})
export class EnrollStudentsBusesSystemComponent implements OnInit {
  tableControls: any = { data: [] };
  sortBy = "route_name";
  sortOrder = "asc";
  searchText = "";
  dataArray = [];
  rowsView = 'list';
  listType = 'enroll-bus-students';
  selectedStudentsToAddToBuses = [];
  modalFlag = 'add';
  filterValues: Filter;
  formFlag = 'single';
  rowsNumber;
  loading = true;
  currLang;
  from: number;
  to: number;
  total: number;
  currentPage: number;
  rowsSubscription;
  viewSubscription;
  searchSubscription;
  filterSubscription;
  callApi = true;
  callEnrollApi = true;
  constructor(
    private dataService: DataService,
    private routesService: RoutesService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private busesStudentsService: BusStudentsService,
    private _router: Router,
    private errorMsgService: ErrorMsgService,
  ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);


    });
    this.rowsSubscription = new Subscription();
    this.viewSubscription = new Subscription();
    this.searchSubscription = new Subscription();
    this.filterSubscription = new Subscription();
  }

  ngOnDestroy(): void {
    this.cancelModalHandler()
    this.dataService.setSearchText("")
    this.dataService.setFilterFlag('close');
    this.rowsSubscription.unsubscribe();
    this.viewSubscription.unsubscribe();
    this.searchSubscription.unsubscribe();
    this.filterSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    $(document).on('shown.bs.modal', '#enrollStudents', () => {
      // this.loading = true;
      // this.dataService.toggleEnrollStatus(true);
    })
    this.currentPage = 1;
    this.loading = true;
    $(document).on('hidden.bs.modal', '#enrollStudents', () => {
      this.dataService.setFilterValue(new Filter());
      this.dataService.setFilterFlag('close');
      this.dataService.toggleEnrollStatus(false);
      this.cancelModalHandler();
    })
    let f = this.dataService.getFilterValue().subscribe((res: any) => {
      this.currentPage = 1;
      this.loading = true
      this.filterValues = res;
      this.getAllStudentsNotInBusesSystem();
    })
    this.filterSubscription.add(f)

    let v = this.dataService.getRowsStyle().subscribe((res: any) => {
      this.currentPage = 1;
      this.rowsView = res ? 'compact' : 'list';
      this.getAllStudentsNotInBusesSystem();
    })
    this.viewSubscription.add(v);

    let r = this.dataService.getRowsNumberShown().subscribe((res: any) => {

      this.rowsNumber = res;
    })
    this.rowsSubscription.add(r);

    let s = this.dataService.getSearchText().subscribe((res: any) => {
      this.currentPage = 1;
      if (res !== null) {
        this.loading = true
        this.searchText = res;
        this.getAllStudentsNotInBusesSystem();
      }
    })
    this.searchSubscription.add(s);

  }



  getAllStudentsNotInBusesSystem() {
    if (this.callApi) {
      this.callApi = false;
      this.busesStudentsService.getAllStudentsNotJoinedBusSystem(1, 25, this.sortBy, this.sortOrder, this.searchText, this.currentPage, this.filterValues)
        .subscribe((res: any) => {
          this.dataArray = [];
          this.from = res.from;
          this.to = res.to;
          this.total = res.total;
          res['data'].forEach(element => {
            this.dataArray.push({
              image_path: element.image_path,
              name: element.name,
              grade_name: element.class?.grade?.name,
              id: element.id
            });
          });
          this.translate.get('init').subscribe(res => {
            this.setTableData(this.dataArray);
          });
          this.translate.onLangChange.subscribe(res => {
            this.setTableData(this.dataArray);
          })
          this.selectedStudentsToAddToBuses.map(student => {
            this.tableControls.data.map(singleData => {
              if (singleData.id === student.id) {
                singleData['isSelected'] = true;
              }
            })
          })
        }, err => { },
          () => {
            setTimeout(() => {
              this.callApi = true;
              this.loading = false;
            }, 500);
          })
    }

  }

  setTableData(data) {
    this.tableControls = {
      selection: true,
      paging: true,
      view: this.rowsView,
      showSelectionNumberFlag: false,
      title: 'table-view.titles.students',
      selectedTitle: 'table-view.selected-titles.students',
      totalTitle: 'table-view.total-titles.students',
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total
      },
      columns: [
        {
          name: '',
          sort: false,
          type: 'image',
          source: 'image_path'
        },
        {
          name: this.translate.instant('buses.enroll-bus.school-students'),
          sort: true,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('buses.enroll-bus.grade'),
          sort: true,
          type: "string",
          source: "grade_name"
        }
      ],
      data: data
    }
    this.loading = false;
  }

  cancelModalHandler() {
    this.dataService.setRowsNumberShown(this.rowsNumber);
    this.sortBy = "route_name";
    this.sortOrder = "asc";
    this.searchText = "";
    this.formFlag = 'single';
    this.selectedStudentsToAddToBuses = [];
    this.dataService.setFilterValue(new Filter());
    // this.clearAll();
  }

  paginationHandling(event) {
    this.currentPage += event.dir;
    this.getAllStudentsNotInBusesSystem();
  }

  tableEventHandeler(event) {
    switch (event.action) {
      case "rowClicked":
        this.rowClicked(event.target);
        break;
      case "sorting":
        this.sorting(event.target);
        break;
      case 'checkboxChanged':
        this.checkBoxHandler(event)
        break;

      case "pagination":
        this.paginationHandling(event.target);
        break;
      default:
        break;
    }
  }

  selectedStudentsEventHandler(event) {
    switch (event.action) {
      case 'removeStudent':
        this.removeFromRoute(event.studentToBeRemoved);
        break;
      case 'clearAll':
        this.clearAll();
        break;
      default:
        break;
    }
  }

  removeFromRoute(student) {
    if (this.formFlag === 'all') {
      this.routesService.disableCheckAllBtn();
      let toBeUnSelectedStudent = this.selectedStudentsToAddToBuses.findIndex(selectedStudent => selectedStudent.id === student.id);
      this.selectedStudentsToAddToBuses[toBeUnSelectedStudent].isSelected = false;
      this.selectedStudentsToAddToBuses = this.selectedStudentsToAddToBuses.filter(selectedStudent => selectedStudent.id !== student.id);
      if (this.modalFlag === 'add') {
        // unselect the unchecked student from tablecontrols array when // create route
        toBeUnSelectedStudent = this.tableControls.data.findIndex(selectedStudent => student.id === selectedStudent.id);
        this.tableControls.data[toBeUnSelectedStudent].isSelected = false;
      }
      else {
        // edit route   push student back to unselected students if the student doesnt exist in the unselected list
        let studentIndex = this.tableControls.data.findIndex(studentData => studentData.id === student.id);
        if (studentIndex === -1) {
          // the student doesnt exist in the unselected list
          this.tableControls.data.push(student);
          this.busesStudentsService.enrollStudentsInBusSystem(student).subscribe(res => console.log(res))
        }
        else {
          this.tableControls.data[studentIndex].isSelected = false;
        }
      }
      this.busesStudentsService.clearSingleStudentFunc({ 'toBeUncehckedStudent': toBeUnSelectedStudent, student })
    }
    else {
      let toBeUncehckedStudent = this.selectedStudentsToAddToBuses.findIndex(selectedStudentdCb => student.id === selectedStudentdCb.id);
      this.selectedStudentsToAddToBuses[toBeUncehckedStudent].isSelected = false;
      this.selectedStudentsToAddToBuses = this.selectedStudentsToAddToBuses.filter(selectedStudent => selectedStudent.id !== student.id);
      if (this.modalFlag === 'add') {
        // unselect the unchecked student from tablecontrols array
        toBeUncehckedStudent = this.tableControls.data.findIndex(selectedStudent => student.id === selectedStudent.id);
        this.tableControls.data[toBeUncehckedStudent].isSelected = false;
      }
      else {
        // edit route   push student back to unselected students if the student doesnt exist in the unselected list
        let studentIndex = this.tableControls.data.findIndex(studentData => studentData.id === student.id);
        if (studentIndex === -1) {
          // the student doesnt exist in the unselected list
          this.tableControls.data.push(student);
        }
        else {
          this.tableControls.data[studentIndex].isSelected = false;
        }
      }
      this.busesStudentsService.clearSingleStudentFunc({ toBeUncehckedStudent, student })
    }
  }

  clearAll() {
    this.selectedStudentsToAddToBuses = [];
    this.routesService.disableCheckAllBtn();
    this.busesStudentsService.clearAllStudents();
    this.tableControls.data.map(singleData => {
      singleData['isSelected'] = false;
    })
  }


  selectChanged(event) {
    event.index;
    event.data;
    event.checked;
  }

  rowClicked(event) {
    event.index;
    event.data;
  }

  sorting(event) {
    this.sortOrder = event.order;
    this.sortBy = event.source;
    this.getAllStudentsNotInBusesSystem();
  }

  enrollStudentsInBusSystem() {
    if (this.callEnrollApi) {
      this.callEnrollApi = false;
      let student_ids: any = [];
      this.selectedStudentsToAddToBuses.map(selectedStudent => {
        student_ids.push(selectedStudent.id)
      })
      let body = { 'student_ids': student_ids }
      this.busesStudentsService.enrollStudentsInBusSystem(body).subscribe(res => {
        this.callEnrollApi = true;
        $("#enrollStudents").modal("hide");
      }, err => {
        this.errorHandler(err);
      })
    }

  }

  // Main handler for checkbox events
  checkBoxHandler(event: any) {
    // Determine the type of checkbox action based on the index, handling either "all" or "single" selections
    switch (event.target.index) {
      case 'all': // Case when the "select all" checkbox is toggled
        this.formFlag = 'all'; // Set formFlag to indicate "all" selection mode for reference in other logic

        // If the "select all" checkbox is checked, call the method to select all students on the page;
        // otherwise, call the method to deselect all students on the page
        event.target.checked ? this.selectAllOnPage() : this.deselectAllOnPage();
        break;

      default: // Default case to handle individual student checkbox changes
        this.formFlag = 'single'; // Set formFlag to indicate "single" selection mode for reference in other logic

        // If the individual student checkbox is checked, select the student by calling selectSingleStudent();
        // otherwise, deselect the student by calling deselectSingleStudent()
        event.target.checked ? this.selectSingleStudent(event.target) : this.deselectSingleStudent(event.target);
        break;
    }
  }

  // Method to select all students on the current page
  selectAllOnPage() {
    // Iterate over each student on the current page
    this.dataArray.forEach(newStudent => {
      // Check if the student is not already in the selected list
      const exists = this.selectedStudentsToAddToBuses.some(student => student.id === newStudent.id);

      // If the student is not selected, mark as selected and add to the list
      if (!exists) {
        newStudent['isSelected'] = true; // Mark as selected
        this.selectedStudentsToAddToBuses.push(newStudent); // Add to selected list
      }
    });

    // Update the selection status in the table data to reflect that all are selected
    this.tableControls.data.forEach(student => {
      student['isSelected'] = true; // Mark each student as selected in the table controls
    });
  }

  // Method to deselect all students on the current page
  deselectAllOnPage() {
    // Remove each student on the current page from the selected list
    this.dataArray.forEach(currentPageStudent => {
      // Filter out the students who are on the current page from the selected list
      this.selectedStudentsToAddToBuses = this.selectedStudentsToAddToBuses.filter(
        selectedStudent => selectedStudent.id !== currentPageStudent.id
      );
    });

    // Update the selection status in the table data to reflect that all are deselected
    this.tableControls.data.forEach(student => {
      student['isSelected'] = false; // Mark each student as deselected in the table controls
    });
  }

  // Method to handle selecting a single student
  selectSingleStudent(target: any) {
    this.selectChanged(target); // Log selection change for debugging purposes

    const studentData = target.data; // Extract student data from the event target

    // Check if the student is not already in the selected list
    const exists = this.selectedStudentsToAddToBuses.some(student => student.id === studentData.id);

    // If the student is not selected, mark as selected and add to the list
    if (!exists) {
      studentData['isSelected'] = true; // Mark as selected
      this.selectedStudentsToAddToBuses.push(studentData); // Add to selected list
    }
  }

  // Method to handle deselecting a single student
  deselectSingleStudent(target: any) {
    this.selectChanged(target); // Log deselection change for debugging purposes

    const studentData = target.data; // Extract student data from the event target
    studentData['isSelected'] = false; // Mark as deselected

    // Remove the student from the selected list
    this.selectedStudentsToAddToBuses = this.selectedStudentsToAddToBuses.filter(
      student => student.id !== studentData.id // Filter out the deselected student
    );
  }

  errorHandler(err: any) {
    if (err.status == 422) {
      this.busesStudentsService.setEnrollErrors(err.error);
      this._router.navigate(['/buses/enroll-errors']);
    }
    else {
      this.errorMsgService.setMessage(err?.error?.message);
    }
  }
}
